import { createStore, useStore as useBaseStore } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

interface ActiveFilterToggleState {
  open: boolean;
  actions: {
    toggleOpen: (payload?: boolean) => void;
  };
}

const createActiveFilterToggleStore = () => {
  return createStore<ActiveFilterToggleState>()(
    devtools(
      immer((set) => ({
        open: true,
        actions: {
          toggleOpen: (payload?: boolean) =>
            set(
              (state) => {
                state.open = payload ?? !state.open;
              },
              false,
              { type: "toggleOpen", payload },
            ),
        },
      })),
      { name: "FilterToggleStore" },
    ),
  );
};

const store = createActiveFilterToggleStore();

export const useActiveFilterToggle = () => useBaseStore(store);
